import styled from 'styled-components';
import { theme } from '../../../theme';
import { SCREEN } from '../../../theme/breakpoints';

const isWeb = SCREEN.isWeb;

interface TracksProps {
  clickEnabled: any;
  padding?: number;
}

// export const Tracks = styled.ol<StyledSystemProps>`
//   display: flex;
//   justify-content: center;
//   margin: 0;
//   padding: 40px 0;
// `;

export const Tracks = styled.ol<TracksProps>`
  display: flex;
  justify-content: ${isWeb ? 'center' : 'space-evenly'};
  margin: 0;
  padding: ${props => (props.padding === undefined ? '40' : props.padding)}px 0;
`;

export const Track = styled.li`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: ${theme.minWidths[isWeb ? 0 : 1]};
  position: relative;

  .side-nav {
    &__wrap {
      align-items: center;
      text-align: center;
      cursor: ${(props: TracksProps) => (props.clickEnabled ? 'pointer' : 'unset')};
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      min-height: ${theme.space[4]}px;
    }

    &__circle {
      align-items: center;
      background-color: ${props => props.theme.colors.primary};
      border-radius: 50%;
      display: flex;
      height: ${theme.space[3]}px;
      justify-content: center;
      margin: ${theme.space[4]}px;
      opacity: 0.5;
      width: ${theme.space[3]}px;

      &-inner {
        background-color: ${props => props.theme.colors.white};
        border-radius: 50%;
        display: block;
        height: ${theme.space[1]}px;
        width: ${theme.space[1]}px;
      }
    }

    &__line {
      background-color: ${props => props.theme.colors.primary};
      border-radius: 2px;
      height: ${theme.space[1] / 2}px;
      opacity: 0.25;
      position: absolute;
      right: -25%;
      width: 50%;
    }
  }

  &:last-child {
    .side-nav__line {
      display: none;
    }
  }

  &.-doing,
  &.-done {
    .side-nav__circle {
      opacity: 1;
    }
  }

  &.-done {
    .side-nav__circle {
      background-color: ${props => props.theme.colors.primary};
    }

    .side-nav__line {
      opacity: 1;
    }
  }

  &.-doing {
    .side-nav__circle {
      background-color: ${props => props.theme.colors.primary};
    }

    .side-nav__page {
      font-weight: 800;
      text-align: center;
    }
  }

  &:hover {
    .side-nav__circle {
      background-color: ${props => props.theme.colors.primaryDark};
    }

    .-done {
      .side-nav__circle {
        background-color: ${props => props.theme.colors.primary};
      }
    }
  }
`;
